import { eChuongTrinhDaoTaoKienThucActionsObj } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoKienThucActions";
import { generateActions } from "../generateActions";

export const chuongTrinhDaoTaoKienThucActions = {
  ...generateActions(
    eChuongTrinhDaoTaoKienThucActionsObj,
    "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
  ),
};
